import { ProductBatchEditSellPricesBodyPricesAbsolutePriceRule } from "./product-batch-edit-sell-prices-body-prices-absolute-price";

export class ProductBatchEditSellPricesBodyPrices{
	AbsolutePriceRule:ProductBatchEditSellPricesBodyPricesAbsolutePriceRule = new ProductBatchEditSellPricesBodyPricesAbsolutePriceRule();
	Discount:boolean = false;
	Debet:boolean = false;
	DiscountPercentage:number = 0.0;
}